import React, { useState, useEffect } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import toast, { Toaster } from "react-hot-toast";
import axios from "../Util/axiosConfig";

const UserResources = () => {
  const [resources, setResources] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    fetchResources();
  }, []);

  const fetchResources = async () => {
    try {
      const response = await axios.get("/v1/api/resources");
      if (response.data.success) {
        setResources(response.data.data);
      }
    } catch (error) {
      toast.error("Failed to fetch resources");
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async (id) => {
    try {
      const response = await axios.get(`/v1/api/resources/download/${id}`);
      if (response.data.success) {
        const { downloadUrl, contentType, fileName } = response.data.data;

        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", fileName);
        link.setAttribute("type", contentType);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      toast.error("Failed to download resource");
    }
  };

  const handleGetLink = async (id) => {
    try {
      const response = await axios.post(
        `/v1/api/resources/generate-link/${id}`
      );
      if (response.data.success) {
        const { downloadLink, expiry } = response.data.data;

        const input = document.createElement("input");
        input.value = downloadLink;
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input);

        toast.success(
          `Download link copied to clipboard! Link expires on ${new Date(
            expiry
          ).toLocaleString()}`
        );
      }
    } catch (error) {
      toast.error("Failed to generate download link");
    }
  };

  const filteredResources = resources.filter(
    (resource) =>
      resource.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      resource.description?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      resource.type.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet>
          <title>Resources Library - UGONSA</title>
        </Helmet>
        <Toaster />

        <div className="container-fluid mt-3">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <h4 className="card-title">Resources Library</h4>
                    <div className="search-box">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search resources..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>
                  </div>

                  {loading ? (
                    <div className="text-center">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : filteredResources.length === 0 ? (
                    <div className="text-center">
                      <p>No resources found</p>
                    </div>
                  ) : (
                    <div className="row">
                      {filteredResources.map((resource) => (
                        <div
                          key={resource.id}
                          className="col-md-6 col-lg-4 mb-4"
                        >
                          <div className="card h-100">
                            <div className="card-body">
                              <h5 className="card-title">{resource.title}</h5>
                              <p className="card-text">
                                {resource.description ||
                                  "No description available"}
                              </p>
                              <div className="mb-3">
                                <span
                                  className={`badge bg-${
                                    resource.type === "book"
                                      ? "info"
                                      : "success"
                                  } me-2`}
                                >
                                  {resource.type}
                                </span>
                                <small className="text-muted">
                                  Downloads: {resource.downloadCount}
                                </small>
                              </div>
                              <div className="btn-group">
                                <button
                                  className="btn btn-primary btn-sm"
                                  onClick={() => handleDownload(resource.id)}
                                >
                                  <i className="mdi mdi-download me-1"></i>
                                  Download
                                </button>
                                <button
                                  className="btn btn-outline-primary btn-sm"
                                  onClick={() => handleGetLink(resource.id)}
                                >
                                  <i className="mdi mdi-link-variant me-1"></i>
                                  Get Link
                                </button>
                              </div>
                            </div>
                            <div className="card-footer">
                              <small className="text-muted">
                                Added:{" "}
                                {new Date(
                                  resource.createdAt
                                ).toLocaleDateString()}
                              </small>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </HelmetProvider>
    </React.Fragment>
  );
};

export default UserResources;
